import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useHomeSection } from "../../hooks/useHomeContent";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const absolutize = (u) => {
  if (!u) return "";
  if (/^https?:\/\//i.test(u)) return u;
  return `${BACKEND_URL}${u}`;
};

export default function ShopByOccasion() {
  const items = useHomeSection("occasions");
  if (!items.length) return null;

  return (
    <section className="sbo" id="occasions">
      <div className="wrap">
        <motion.div
          className="sbo-head"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <span className="sbo-eyebrow">Shop by Occasion</span>
          <h2>Every celebration, a piece to match.</h2>
        </motion.div>

        <div className="sbo-grid">
          {items.map((o, i) => (
            <motion.div
              key={o.id || o.label}
              className={`sbo-tile sbo-tile-${i % 4}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              viewport={{ once: true, amount: 0.2 }}
            >
              <Link
                to={o.link || o.to || "/"}
                data-testid={`sbo-${(o.label || "").toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="sbo-media">
                  <img src={absolutize(o.image)} alt={o.label} loading="lazy" />
                  <span className="sbo-shine" aria-hidden="true" />
                </div>
                <div className="sbo-body">
                  <h3>{o.label}</h3>
                  <p>{o.sub || o.caption}</p>
                </div>
                <span className="sbo-arrow">
                  <ArrowUpRight size={18} />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
